import { Synchronized } from '#common/util';
import { KeyValueIterator } from '#metastore';
import { parseWasmResult } from '#wasm/common';
export class MetaStoreWasm extends Synchronized {
    mod;
    constructor(mod, mutex) {
        super(mutex);
        this.mod = mod;
    }
    async setUp(nodeId, proxy) {
        this.setUpHandlers(proxy);
        return await this.mutex.runExclusive(async () => {
            // NOTE: it's not obvious, but we need to really await this, as the wasm below will
            // invoke an async handler, which does some network calls and what not
            parseWasmResult(await this.mod.SetUpMetaStore(nodeId));
        });
    }
    async commitKeyValuePairs(data, createNewKeys) {
        return await this.mutex.runExclusive(async () => {
            return parseWasmResult(await this.mod.CommitKeyValuePairs(data, createNewKeys));
        });
    }
    async getIterator(range) {
        return await this.mutex.runExclusive(async () => {
            const result = parseWasmResult(await this.mod.GetIterator(range.start, range.limit));
            return new KeyValueIterator(result.kvs, result.isTruncated);
        });
    }
    async getKeyValue(key) {
        const iterator = await this.getIterator({ start: key, limit: key });
        const element = iterator.next();
        if (element.done == true) {
            return undefined;
        }
        return element.value.value;
    }
    async deleteKeys(data) {
        return await this.mutex.runExclusive(async () => {
            return parseWasmResult(await this.mod.DeleteKeys(data));
        });
    }
    setUpHandlers(proxy) {
        this.setApplyDataHandler(proxy);
        this.setFetchDataHandler(proxy);
        this.setInvokeProcedureHandler(proxy);
    }
    setApplyDataHandler(proxy) {
        this.mod['applyDataHandler'] = async (start, limit, data, startTime, currentTime) => {
            this.checkWasmReentrance();
            return await proxy.applyData(start, limit, data, startTime, currentTime);
        };
    }
    setFetchDataHandler(proxy) {
        this.mod['fetchDataHandler'] = async (maxKeys, maxSize, start, limit, cursor) => {
            this.checkWasmReentrance();
            return await proxy.fetchData(start, limit, BigInt(maxKeys), BigInt(maxSize), cursor);
        };
    }
    setInvokeProcedureHandler(proxy) {
        this.mod['invokeProcedureHandler'] = async (maxKeys, maxSize, procName, args, cursor) => {
            this.checkWasmReentrance();
            const res = await proxy.invokeProcedure(procName, args, BigInt(maxKeys), BigInt(maxSize), cursor);
            return res;
        };
    }
}
